export default __webpack_public_path__ + "static/media/preExisting.4a4473cc.svg";